import React, { createContext, useState, useContext, useEffect } from 'react';
import { toast } from 'react-toastify';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
      // Initialize cart from localStorage with cart type
      const [cartItems, setCartItems] = useState(() => {
            const savedCart = localStorage.getItem('guestCart');
            return savedCart ? JSON.parse(savedCart) : [];
      });

      const [isPublicCheckout, setIsPublicCheckout] = useState(false);

      // Sync cart with localStorage whenever it changes
      useEffect(() => {
            localStorage.setItem('guestCart', JSON.stringify(cartItems));
      }, [cartItems]);

      const addToCart = (artwork) => {
            // Check if item already exists in cart
            if (cartItems.some(item => item.listingID === artwork.listingID)) {
                  toast.info('This item is already in your cart');
                  return;
            }

            setCartItems(prevItems => [...prevItems, artwork]);
            toast.success('Added to cart');
      };

      const removeFromCart = (nftId) => {
            setCartItems(prevItems => {
                  // Log for debugging
                  console.log('Removing item with nftId:', nftId);
                  console.log('Current items:', prevItems);
                  
                  // Filter out the item with matching nftId
                  const updatedItems = prevItems.filter(item => item.nftId !== nftId);
                  
                  // Log the result
                  console.log('Updated items:', updatedItems);
                  
                  if (updatedItems.length === prevItems.length) {
                        toast.error('Item not found in cart');
                        return prevItems;
                  }
                  
                  toast.info('Removed from cart');
                  return updatedItems;
            });
      };

      const clearCart = () => {
            setCartItems([]);
            localStorage.removeItem('guestCart');
            setIsPublicCheckout(false);
      };

      const getCartTotal = () => {
            return cartItems.reduce((total, item) => total + Number(item.price), 0);
      };

      const startPublicCheckout = () => {
            setIsPublicCheckout(true);
      };

      // Add a method to check if cart has items
      const hasItems = () => {
            return cartItems.length > 0;
      };

      return (
            <CartContext.Provider value={{
                  cartItems,
                  addToCart,
                  removeFromCart,
                  clearCart,
                  getCartTotal,
                  isPublicCheckout,
                  startPublicCheckout,
                  hasItems,
            }}>
                  {children}
            </CartContext.Provider>
      );
};

export const useCart = () => {
      const context = useContext(CartContext);
      if (!context) {
            throw new Error('useCart must be used within a CartProvider');
      }
      return context;
}; 